<script setup lang="ts">
import type { TpgChangeEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarComboBoxOptions {
  label: string;
  value: string;
  leadingIconTemplate?: string;
  badgeLabel?: string;
  props?: object;
}

export interface GrammarComboBoxRenderOption extends GrammarComboBoxOptions {
  hide?: boolean;
  sortValue: number;
  originalOrder: number;
}

export interface GrammarComboBoxProps {
  formAssociated?: boolean;
  selectedValue?: string;
  label?: string;
  value?: string;
  message?: string;
  placeholder?: string;
  type?: 'default' | 'error' | 'warning' | 'danger';
  clearButton?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  leadingIconTemplate?: IconConstant | '';
  options?: GrammarComboBoxOptions[];
  shouldSort?: boolean;
  name?: string;
  maxRenderedOptions?: number;
  customRenderMenuItem?: (option: GrammarComboBoxRenderOption) => object | undefined;
}

const props = withDefaults(defineProps<GrammarComboBoxProps>(), {
  formAssociated: true,
  options: () => [],
  selectedValue: '',
  label: '',
  value: '',
  message: '',
  placeholder: '',
  type: 'default',
  clearButton: false,
  fullWidth: false,
  disabled: false,
  readOnly: false,
  leadingIconTemplate: '',
  shouldSort: true,
  maxRenderedOptions: 100,
  customRenderMenuItem: undefined,
});

const emit = defineEmits(['tpgChange']);

function onChange(event: TpgChangeEvent<string>) {
  emit('tpgChange', event);
}
</script>

<template>
  <tpg-combo-box v-bind="props" @tpg-change="onChange" />
</template>
